export default "__VITE_ASSET__BZS2vHeC__"